import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const organisationCurrentSettingsSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentSettings.select();
